require('./incident-tab.component.scss');
class IncidentTabController {
  constructor(
    $scope,
    $http,
    PermissionService,
  ) {
    this.$scope = $scope;
    this.permission = PermissionService;
    $scope.configs = {
      // accountConf: [],
      agentConf: [],
    };

    if (!$scope.filter.switch_to) {
      $scope.filter.switch_to = {
        // accountConf: null,
        agentConf: null,
      };
    }

    $http.get('/analytics/configs_lists/').then(data => {
      this.$scope.configs = {
        // accountConf: this.setName(data.data.object_list.AccountConf),
        agentConf: this.setName(data.data.object_list.AgentConf),
      };
    });
  }

  setName(list) {
    const nameKey = this.permission.selectedLang === 'ru' ? 'name_ru' : 'name_en';
    return list.map(c => ({
      id: c.id,
      name: c[nameKey],
    }));
  }

}

export function IncidentTabComponent() {
  return {
    restrict: 'E',
    template: require('./incident-tab.component.html'),
    scope: false,
    controller: IncidentTabController,
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/incident-tab.component.js